module.exports = __webpack_public_path__ + "img/naifenxingqiu.a7fa9eb5.png";